<template>
  <div ref="right">
    <div class="params" ref="params">
      <el-form :model="currentLayersParams" :inline="true" label-width="80px" label-position="right" size="mini">
        <el-form-item label="坐标：">
          <el-input-number :disabled="comDisabled" class="form-val" v-model="currentLayersParams.left" :precision="0" @change='updateCanvas("left")' controls-position="right"></el-input-number>
          <span class="explain">X</span>
        </el-form-item>
        <el-form-item label="坐标：">
          <el-input-number class="form-val" :disabled="comDisabled" v-model="currentLayersParams.top" :precision="0" @change='updateCanvas("top")' controls-position="right"></el-input-number>
          <span class="explain">Y</span>
        </el-form-item>
        <el-form-item label="旋转：">
          <el-input-number class="form-val" :disabled="comDisabled" v-model="currentLayersParams.rotate" :precision="0" @change='updateCanvas("rotate")' controls-position="right"></el-input-number>
          <span class="explain">角度</span>
        </el-form-item>
        <el-form-item label="填充色：" v-show="showFill">
          <el-color-picker class="form-val color" :disabled="comDisabled" v-model="currentLayersParams.fill" @change='updateCanvas("fill")'></el-color-picker>
          <span class="explain"></span>
        </el-form-item>
        <el-form-item label="画笔色：">
          <el-color-picker class="form-val color" :disabled="comDisabled" v-model="currentLayersParams.stroke" @change='updateCanvas("stroke")'></el-color-picker>
          <span class="explain"></span>
        </el-form-item>
        <el-form-item label="文字：" v-if="this.currentLayersParams.type=='text'">
          <el-input v-model="currentLayersParams.title" :disabled="comDisabled" class="form-val" type="textarea" resize="none" rows="2" placeholder=""></el-input>
          <span class="explain"></span>
        </el-form-item>
        <el-form-item label="">
          <!-- <el-button type="primary" size="mini" @click="exportPNG">导出PNG</el-button> -->
          <!-- <el-button type="primary" size="mini" @click="exportJSONData">导出JSON</el-button> -->
          <el-upload class="upload" action="" :http-request=uploadData :show-file-list=false>
            <el-button size="mini" type="primary">上传dwg</el-button>
          </el-upload>
          <!-- <span class="explain"></span> -->
        </el-form-item>
      </el-form>
    </div>
    <!-- <img :src="baseSrc" alt=""> -->
    <div class="layers scrollbar" ref="layers" v-show="layers.length>0">
      <div v-for="(item,index) in layers" :index=index :key=index draggable=true @dragstart="drag" @drop="drop" @dragover="dragover" :class="[index % 2==0?'even':'odd',activeLayerIndex==index?'actived':'']" @click="clickLayer(item,index)" class="layer-item">
        <i class="view el-icon-view" :class="{'view-active':item.visible}" @click.stop="toggleVisiable(item)"></i>
        <!-- <span class="title">{{item.tucengName}}</span> -->
        <el-input class="title" size="mini" :disabled="!item.isEditTuceng" :class="item.isEditTuceng?'':'unedit-tuceng'" v-model="item.customData.tucengName" @dblclick.native="dbclickTuceng(item)" @blur="blurTuceng(item)"></el-input>
        <!-- <span class="des" v-show="!item.isEditDes" v-if="item.data">{{item.data.des}}</span> -->
        <el-input class="des" size="mini" v-if="item.subCustomData && item.subCustomData.des" :disabled="!item.isEditDes" :class="item.isEditDes?'':'unedit-tuceng'" v-model="item.subCustomData.des" @dblclick.native="dbclickDes(item)" @blur="blurDes(item)"></el-input>
        <i class="del el-icon-delete" @click.stop="delItem(item)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'onLinePSRight',
  props: {
    activedFabricObj: Object,
    currentFarbicPar: Object,
    fabricObj: Object,
    layers: Array,
    propsData:Object
  },
  data() {
    return {
      baseSrc: '',
      currentLayersParams: {
        left: '',
        top: '',
        title: '',
        rotate: '',
        fill: '',
        stroke: '',
        type: ''
      },
      loading: null,
      activeLayerIndex: -1,
      moveIndex: 0, //拖动开始位置index
      movedIndex: 0 //拖动放置位置index
    }
  },
  watch: {
    currentFarbicPar: {
      handler(newV) {
        if (newV) {
          this.currentLayersParams = newV
          this.setSelectedLayer()
        }
      },
      deep: true
    }
  },
  computed: {
    comDisabled() {
      return (
        this.activeLayerIndex >= 0 &&
        !this.layers[this.activeLayerIndex].visible
      )
    },
    showFill() {
      if (this.currentLayersParams.type.indexOf('line') >= 0) {
        return false
      }
      return true
    }
  },
  mounted() {
    this.$nextTick(() => {
      let allObjects = this.fabricObj.fabricObjInst.getObjects()
      this.setLayersHeight()
    })
    // this.currentLayersParams = this.layers[0]
  },
  methods: {
    setLayersHeight() {
      let height = this.$refs.right.clientHeight
      let paramH = this.$refs.params.clientHeight
      let self = this
      setTimeout(() => {
        self.$refs.layers.style.height = height - paramH - 20 + 'px'
      }, 100)
    },
    setSelectedLayer() {
      if (this.layers.length > 0) {
        this.layers.forEach((element, i) => {
          if (element.order == this.currentLayersParams.order) {
            this.activeLayerIndex = i
          }
        })
      }
    },
    dbclickDes(item) {
      this.$set(item, 'isEditDes', true)
    },
    blurDes(item) {
      this.$set(item, 'isEditDes', false)
      this.fabricObj.set(
        item.order,
        'subCustomData',
        { des: item.subCustomData.des },
        'sub'
      )
      this.fabricObj.set(item.order, 'text', item.subCustomData.des, 'sub')
    },
    dbclickTuceng(item) {
      this.$set(item, 'isEditTuceng', true)
    },
    blurTuceng(item) {
      this.$set(item, 'isEditTuceng', false)
      this.fabricObj.set(item.order, 'customData', {
        tucengName: item.customData.tucengName
      })
    },
    toggleVisiable(item) {
      item.visible = !item.visible
      this.fabricObj.toggleVisiable(item.visible, item.order)
    },
    updateCanvas(type) {
      let val = this.currentLayersParams[type]
      if (type == 'top' || type == 'left') {
        val = val / this.currentLayersParams.zoomX
        this.activedFabricObj.set(type, val).setCoords()
      } else if (type == 'rotate') {
        this.activedFabricObj.rotate(val)
      } else if (type == 'stroke' || type == 'fill') {
        let updateObj = this.activedFabricObj
        if (this.currentFarbicPar.isGroup) {
          //球标组
          updateObj =
            type == 'stroke'
              ? this.activedFabricObj.item(1)
              : this.activedFabricObj
          // this.activedFabricObj.item(0).set(type, val)
          this.activedFabricObj
            .item(0)
            .item(0)
            .set(type, val)
          this.activedFabricObj
            .item(0)
            .item(1)
            .set(type, val)
        }
        updateObj.set(type, val)
        console.log(updateObj)
      }
      this.$emit('renderAll')
    },
    clickLayer(item, index) {
      this.activeLayerIndex = index
      this.currentLayersParams = this.layers[index]
      this.fabricObj.setActiveSelect(
        item.order,
        this.$parent.setActiveObjectCallback
      )
    },
    delItem(item) {
      this.$confirm('确认删除该图层？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fabricObj.delObj(item.order)
      })
    },
    startLoading() {
      this.loading = this._global.loading(this, '正在加载中...')
    },
    endLoading() {
      this.loading.close()
    },
    uploadData(file) {
      let form = new FormData()
      form.append('file', file.file)
      form.append('CID', this.propsData.svgId)
      form.append('Status', 1)  //1上传dwg
      this.startLoading()
      let self = this
      ApiService.amis.excuteDWG(form).then(res => {
        if (res.code == 0) {
          let url = res.data
          try {
            this.$bus.$emit('getUploaddwg',1)
            this._global.convertImgToBase64(url, res => {
              this.fabricObj.createBGIMG(res, this.endLoading, 'clear')
            }).catch(res=>{
              this.endLoading()
              alert('上传失败！')
            })
          } catch (e) {
            this.endLoading()
          }
        }
      })
    },
    drag(ev) {
      let idx = parseInt(ev.currentTarget.getAttribute('index'))
      this.moveIndex = idx
    },
    drop(ev) {
      ev.preventDefault()
      // if (this.movedIndex == 0 || this.moveIndex == 0) {
      //   return
      // }
      let moveObj = this.layers.splice(this.moveIndex, 1)
      this.layers.splice(this.movedIndex, 0, moveObj[0])
      let moveOrder = this.layers[this.moveIndex].order
      let movedOrder = this.layers[this.movedIndex].order
      this.fabricObj.updateLevel(
        this.moveIndex,
        this.movedIndex,
        moveObj[0].order
      )
    },
    dragover(ev) {
      ev.preventDefault()
      this.movedIndex = parseInt(ev.currentTarget.getAttribute('index'))
    }
  }
}
</script>

<style scoped lang='scss'>
.params {
  ::v-deep {
    .el-color-picker__trigger {
      width: 60%;
      .el-color-picker__icon,
      .el-color-picker__empty {
        display: none;
      }
    }
  }
}
.explain {
  display: inline-block;
  width: 45px;
  text-align: left;
  padding-left: 5px;
}
.form-val {
  width: 150px;
}
.layers {
  margin-top: 15px;
  width: 90%;
  margin: 0 auto;
  border: 1px solid #ccc;
  border-radius: 3px;
  // height: 395px;
  overflow: overlay;
  // height: calc()
}
.actived {
  background: rgba(55, 134, 255, 0.4) !important;
}
.view-active {
  color: #4a89f8;
}
.upload {
  display: inline-block;
  margin-left: 20px;
}
.unedit-tuceng {
  ::v-deep {
    .el-input__inner {
      border: none;
      background-color: transparent;
    }
  }
}
.layer-item {
  line-height: 0.4rem;
  font-size: 0.14rem;
  text-align: left;
  padding-left: 20px;
  cursor: pointer;
  ::v-deep {
    .el-input__inner {
      padding: 0 5px;
    }
    .el-input.is-disabled .el-input__inner {
      cursor: context-menu;
      color: #606266;
    }
  }
  .title {
    margin-left: 5px;
    width: 130px;
    overflow: hidden;
    display: inline-flex;
  }
  .des {
    margin-right: 10px;
    display: inline-flex;
    width: 35px;
  }
  .del {
    float: right;
    line-height: 0.4rem;
    margin-right: 20px;
  }
}
.layer-item:first-child,
.layer-item:last-child {
  border-radius: 3px;
}
.even {
  background-color: white;
}
.odd {
  background-color: #f9f9f9;
}
</style>


// WEBPACK FOOTER //
// src/components/editImg/right.vue